<template>
    <i :class="[prefix + 'proj-icon', fontClass, baseType + '-' + type]" :style="styles"></i>
</template>
<script>
    export default {
        name: 'ProjIcon',
        props: {
            type: {
                type: String,
                required: true
            },
            color: {
                type: String,
                default: '#5c6b77'
            },
            size: {
                type: Number,
                default: 16
            },
            fontClass: {
                type: String,
                default: "iconfont"
            },
            baseType: {
                type: String,
                default: "icon"
            }
        },
        computed: {
            prefix(){
                return "ivu-"
            },
            styles() {
                return {
                    fontSize: `${this.size}px`,
                    color: this.color
                }
            }
        }
    }
</script>
<style>
</style>